import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  Alert,
  AlertTitle,
  Box,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { setDataState } from '../../../actions/data';

export default function NewFileAdditionalData() {

  const { file_new: file } = useSelector(state => state.data);
  const { file_name } = file;

  const dispatch = useDispatch();

  const [data, setData] = useState({
    file_name: file_name || '',
    file_comments: '',
  });

  const handleDataChange = (event) => {
    const { name, value } = event.target;
    setData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // update local useState values on new file/file change
  useEffect(() => {
    if (file_name) {
      setData({
        ...file,
        file_name: file_name,
        file_comments: '',
      })
    }
  }, [setData, file_name]);

  // update values in redux
  useEffect(() => {
    if (data?.file_name) {
      dispatch(setDataState('file_new', data));
    }
  }, [data]);

  return (
    <>
      { file_name ?
        <>
          <Grid container id="files-create-new-file-additional-data-file-name" sx={{ my: 1 }}>
            <Grid item xs={12}>
              <Typography><strong>New File: Name</strong></Typography>
            </Grid>
            <Grid item xs={12} sx={{ boxShadow: 10, borderRadius: 1, my: 1 }}>
              <Alert severity="info" variant="outlined">
                <AlertTitle><strong>Optional</strong></AlertTitle>
                <Box>
                  Overwrite the default file name so you can easy identify it later.
                  It might be a good idea to include a type of the File, date, project name, etc.
                  Be as descriptive as possible, as any format is accepted here
                </Box>
                <Box>
                </Box>
              </Alert>
            </Grid>
            <Grid item xs={12} sx={{ m: 1 }}>
              <TextField
                type="text"
                name="file_name"
                variant="standard"
                size='small'
                margin='normal'
                fullWidth
                required={true}
                multiline={false}
                rows={1}
                value={data.file_name}
                onChange={handleDataChange}
                autoFocus
              />
            </Grid>
          </Grid>
          <Grid container id="files-create-new-file-additional-data-file-comments">
            <Grid item xs={12} sx={{ my: 1 }}>
              <Typography><strong>New File: Comments</strong></Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ m: 1 }}>
            <TextField
              type="text"
              name="file_comments"
              placeholder="Any additional information related to this File"
              variant="standard"
              size='small'
              margin='normal'
              fullWidth
              required={false}
              multiline={true}
              rows={5}
              value={data.file_comments}
              onChange={handleDataChange}
            />
          </Grid>
        </>
        : null
      }
    </>
  )
}
